import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';

export interface SettingsTabProps {
}

@observer export class SettingsTab extends Component<SettingsTabProps, any> {

    render() {
        return <div>Settings tab</div>
    }

}
